import OpenContentLibraryPicker from "./OpenContentLibraryPicker";
import CONTENT_LIBRARY_URL_FILE_NAME from "./Constants";

export interface ContentLibraryPickerAuthParams {
  accountKey: string;
  sessionId?: string | null;
  userId?: string | null;
}

function OpenDefaultFileChooser(options: any) {
  if (!options || !options.input) return;
  const input: HTMLInputElement = options.input as HTMLInputElement;
  input.value = "";
  input.onchange = () => {
    if (!input.files || input.files.length < 1) return;
    const files: File[] = [];
    for (let i = 0; i < input.files.length; i += 1) {
      files.push(input.files[i]);
    }
    options.callback(files);
  };
  input.click();
}

export default function AttachContentLibraryFileChooser(
  surveyCreator: any,
  auth: ContentLibraryPickerAuthParams,
) {
  if (!surveyCreator || !surveyCreator.onOpenFileChooser) return;

  surveyCreator.onOpenFileChooser.add((sender: any, options: any) => {
    const accept = (options && options.input && options.input.accept) || "";
    const isImageAccept = typeof accept === "string" && accept.toLowerCase().indexOf("image") >= 0;

    if (!isImageAccept || !auth || !auth.accountKey) {
      OpenDefaultFileChooser(options);
      return;
    }

    OpenContentLibraryPicker({
      accountKey: auth.accountKey,
      sessionId: auth.sessionId,
      userId: auth.userId,
    })
      .then((asset) => {
        if (!asset || !asset.url) {
          return;
        }

        const markerFile = new File([asset.url], CONTENT_LIBRARY_URL_FILE_NAME, {
          type: "text/plain",
        });
        options.callback([markerFile]);
      })
      .catch(() => {
        OpenDefaultFileChooser(options);
      });
  });
}
